import reqwest from 'reqwest';
import { cookie, log } from '../base';
import Whitelist from './whitelist';
import JPromise from './promise';
// import Token from './token';

module.exports = {
  /**
   * ajax封装
   * @param {object}  params 入参
   */
  ajax(params) {
    let { tars_domain } = this._validityDomain(params.skipValidate);
    
    let request_url = tars_domain + params.url;
    const {
      tenantKey,
      userId
    } = __tars_config__;

    // 如果写了完整路径，直接发请求，不改造。这个用于dip测试
    if (params.url.indexOf('http') === 0) {
      request_url = params.url;
    }

    if (!params.data) params.data = {};

    const request_data = Object.assign({
      _tenant_key_: tenantKey,
    }, params.data);

    if (userId) {
      request_data._userId_ = userId;
    }

    const request_option = {
      url: request_url,
      type: params.type || 'json',
      method: params.method || 'get',
      crossOrigin: true,
      withCredentials: true,
      data: request_data
    };
    
    // 如果是非get请求，携带__tars_token__参数
    if (params.method && params.method.toLowerCase() !== 'get') {
      let __tars_token__ =  cookie.getCookie('__tars_token__');
      // let security_token = Token.getToken(JSON.stringify(request_option.data), __tars_token__);
      // request_option.data.__tars_sign__ = security_token;
      request_option.data.__tars_token__ = __tars_token__;
    }

    if (params.success) {
      reqwest(request_option).then((res)=>{
        // 如果第一次token校验返回 2054 错误，则重试一次
        if(!res.success && res.error && res.error.code === 2054){
          // let security_token = Token.getToken(JSON.stringify(request_option.data), res.__tars_token__);
          // 设置cookie，且60分钟过期
          cookie.setCookie('__tars_token__', res.__tars_token__, 60 * 60);
          request_option.data.__tars_token__ = res.__tars_token__;
          // request_option.data.__tars_sign__ = security_token;
          reqwest(request_option).then((secondRes)=>{
            params.success && params.success(secondRes);
          }).fail((secondRes)=>{
            params.error && params.error(secondRes);
          })
        } else {
          params.success && params.success(res);
        }
      }).fail((res)=>{
        params.error && params.error(res);
      })
    } else {
      return new JPromise((resolve, reject) => {
        reqwest(request_option).then((res)=>{
          // 如果第一次token校验返回 2054 错误，则重试一次
          if(!res.success && res.error && res.error.code === 2054){
            // let security_token = Token.getToken(JSON.stringify(request_option.data), res.__tars_token__);
            // 设置cookie，且60分钟过期
            cookie.setCookie('__tars_token__', res.__tars_token__, 60 * 60);
            request_option.data.__tars_token__ = res.__tars_token__;
            // request_option.data.__tars_sign__ = security_token;
            reqwest(request_option).then((secondRes)=>{
              resolve(secondRes)
            }).fail((secondRes)=>{
              reject(secondRes)
            })
          } else {
            resolve(res);
          }
        }).fail((res)=>{
          reject(res)
        })
      });
    }
  },

  /**
   * 合法性检查
   */
  _validityDomain() {
    if (!window.__tars_config__) {
      log.warning('系统__tars_config__配置缺失');
      return;
    }
    const {
      env,
      aliNetwork
    } = window.__tars_config__;
    let tars_domain = 'https://';
    let validate_domain = null;

    if (env === 'prod') {
      if (aliNetwork) {
        // 弹内办公网
        validate_domain = Whitelist.prod.ali;
        tars_domain += 'tars.cainiao-inc.com';
      } else {
        // 弹外办公网
        validate_domain = Whitelist.prod.ali;
        tars_domain += 'tars.cainiao.com';
      }
    } else if (env === 'pre') {
      if (aliNetwork) {
        // 弹内办公网
        validate_domain = Whitelist.pre.ali;
        tars_domain += 'pre-tars.cainiao-inc.com';
      } else {
        // 弹外办公网
        validate_domain = Whitelist.pre.ali;
        tars_domain += 'pre-tars.cainiao.com';
      }
    } else {
      // 日常不区分弹内弹外
      validate_domain = Whitelist.daily;
      tars_domain += 'tars.cainiao.test';
    }

    return {
      tars_domain,
      validate_domain
    };
  },
}


// WEBPACK FOOTER //
// ./src/net/index.js